import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=d7a439ba&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
import style0 from "./Review.vue?vue&type=style&index=0&id=d7a439ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a439ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7a439ba')) {
      api.createRecord('d7a439ba', component.options)
    } else {
      api.reload('d7a439ba', component.options)
    }
    module.hot.accept("./Review.vue?vue&type=template&id=d7a439ba&scoped=true", function () {
      api.rerender('d7a439ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/Review.vue"
export default component.exports